import React from "react";
import { colors, responsiveFontSizes, TextField } from "@mui/material";
import { Height, Margin } from "@mui/icons-material";

const feildcolor = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {border: "1px solid  #000", width:"100%",height:"40px",alignSelf:"center"},
    "&:hover fieldset": { border: "2px solid  #000",color:"gray"},
    "&.Mui-focused fieldset": { border: "1px solid  #154A72"}, },
  "& .MuiInputLabel-root": { top: "3px",fontSize:"13px"},
  "& .MuiInputLabel-shrink": { top: "10px",color:"#154A72",fontSize:"18px"},
}

const style={width: "100%",  "& .MuiOutlinedInput-root": { borderRadius: "3px", }}
const Input = ({ placeholder,name,value,onChange }) => {
  console.log(placeholder)
  if (placeholder==="Message" || placeholder==="conditions"){
    return <TextField  label={placeholder} variant="outlined" name={name} value={value} onChange={onChange} minRows={4} sx={{...style}}  multiline fullWidth required />;
  }else{
    return <TextField  label={placeholder} variant="outlined" name={name} value={value} onChange={onChange} sx={{...feildcolor,flexGrow:"1"}} fullWidth  required/>;
  }
};

export default Input;

